var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigPyramid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 52,
    viewBox: "0 0 68 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.6L34.35 1L67.13 35.11L31.88 50.83L1 40.6Z",
    fill: "#EED498",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8799 50.83L34.3499 1",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45996 37.57L22.22 43.44",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62988 32.64L22.5999 36.81",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1299 26.2L22.4099 28.66",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.73 21.84L23.55 23.36",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 17.86L25.44 18.81",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1201 13.55L26.9601 13.88",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6502 34.63C48.6502 34.63 42.0202 33.21 41.0702 31.88C40.1202 30.55 39.3602 26.86 39.9302 25.91C40.5002 24.96 43.1502 23.07 43.1502 23.07C43.1502 23.07 46.6602 21.27 48.7402 23.35C50.8202 25.43 51.2002 28.28 50.9202 29.89C50.6402 31.5 48.6502 34.63 48.6502 34.63V34.63Z",
    fill: "#CD7531",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1402 30.08C47.1402 30.08 46.1902 28.66 46.5702 26.95C46.9502 25.24 47.9002 25.43 47.9002 25.43C47.9002 25.43 49.0402 25.9 48.7502 27.51C48.4602 29.12 47.1402 30.07 47.1402 30.07V30.08Z",
    fill: "#E5C677",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6202 31.16C45.5302 31.5 44.2502 31.39 43.3502 31.03C42.4502 30.67 41.7402 28.95 41.7402 28.95C41.7402 28.95 42.4202 28.52 43.4502 28.95C44.5402 29.4 45.8602 31.52 45.6302 31.16H45.6202Z",
    fill: "#E5C677",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7799 21.79L40.1299 19.28",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2398 21.32L46.0898 18.86",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1201 23.03L51.1601 21.94",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8301 25.63L53.2001 24.83",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4902 29.09L54.3802 29.23",
    stroke: "#1D1D1B",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6401 32.88L53.9101 34.02",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8398 36.01L50.8298 37.85",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2398 37.19L44.5298 39.08",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2202 34.16L38.6602 35.91",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6601 29.85L36.1001 30.27",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.56 25.73L36.48 25.06",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPyramid);
export default __webpack_public_path__ + "static/media/BigPyramid.65cba6358d0ee547df8371c5e0415cee.svg";
export { ForwardRef as ReactComponent };